// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W-Pg","icon":"styles_icon__2Rsn5"};